import { render, staticRenderFns } from "./EditAddressDialog.vue?vue&type=template&id=4ef9d4a8&scoped=true"
import script from "./EditAddressDialog.vue?vue&type=script&lang=ts"
export * from "./EditAddressDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditAddressDialog.vue?vue&type=style&index=0&id=4ef9d4a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9d4a8",
  null
  
)

export default component.exports